import baseTheme, { colors } from 'style/theme';

export const nomadInsuranceColors = {
  primaryText: colors.black,
  backdrop: 'rgba(0, 0, 0, 0.7)',

  // modal
  modalBg: {
    primary: colors.white,
    secondary: colors.turquoise
  },
  modalHeaderBg: colors.turquoise,

  // links
  primaryLink: {
    default: colors.black,
    hover: colors.turquoise
  },

  secondaryLink: {
    default: colors.white,
    hover: '#273C49'
  },

  tertiaryLink: {
    default: colors.turquoise
  },

  // buttons
  primaryButton: {
    default: colors.yellow,
    hover: '#FFDF74',
    active: '#FFEBAA',
    text: colors.black
  },

  secondaryButton: {
    default: colors.black,
    hover: '#385264',
    active: '#627886',
    text: colors.white
  },

  flatButton: {
    outline: colors.turquoise,
    hover: colors.dew,
    text: colors.black
  },

  inputs: {
    fountainBlue: {
      base: colors['fountainBlue+4'],
      outline: 'rgba(138, 214, 215, 0.5)',
      border: colors.fountainBlue,
      optionHover: colors['fountainBlue+3']
    },
    gray: {
      base: colors.pickledBluewood4,
      outline: 'rgba(39, 60, 73, 0.25)',
      border: colors.pickledBluewood,
      optionHover: colors.pickledBluewood35
    },
    transparentWhite: {
      base: colors.transparentWhite75,
      outline: 'rgba(39, 60, 73, 0.25)',
      border: colors.pickledBluewood,
      optionHover: colors.pickledBluewood35
    },
    white: {
      base: colors.white,
      outline: 'rgba(39, 60, 73, 0.25)',
      border: colors.pickledBluewood,
      optionHover: colors.pickledBluewood35
    }
  }
};

const theme = {
  ...baseTheme,
  colors: {
    ...colors,
    ...nomadInsuranceColors
  },
  fonts: {
    ...baseTheme.fonts,
    body: 'Inter, sans-serif',
    paragraphSpacing: '-0.02em'
  }
};

export default theme;
